import jQuery from 'jquery';
import Glide from '@glidejs/glide';

window.app = window.app || {};

app.glide = (function glideComponent($, undefined) {
    function initialise(){
        /** p.s. Glide is made globally available by the glide import in takeoff/js/libs/index.js */

        if (document.querySelector('.glide-js-A')) {
            /* original slider settings */
            new Glide('.glide-js-A', {
                type: 'carousel',
                perView: 3,
                gap: 20,
                breakpoints: {
                    400: {
                        perView: 1
                    },
                    800: {
                        perView: 2
                    }
                }
            }).mount();
        }

        if (document.querySelector('.glide-js-B')) {
            /* used by the new museum carousel ("offer-card-gallery" template) */
            new Glide('.glide-js-B', {
                type: 'carousel',
                perView: 5,
                gap: 16,
                peek: { before: 0, after: 60 },
                breakpoints: {
                    640: {
                        perView: 1,
                    },
                    1024: {
                        perView: 2,
                    },
                    1280: {
                        perView: 3,
                    },
                    1536: {
                        perView: 4,
                    }
                }
            }).mount();
        }
    }

    return {
        'init': initialise
    };
})(jQuery);
